import { Component, ComponentInterface, h, Host } from "@stencil/core";

const baseClass = "ux-iws-search-no-results";

@Component({
    tag: "ux-iws-search-no-results",
    styleUrl: "search-no-results.scss",
})
export class SearchNoResults implements ComponentInterface {
    render() {
        return (
            <Host class={baseClass}>
                <ux-icon class={`${baseClass}__icon`} name="magnifier-cross" />
                <slot />
            </Host>
        );
    }
}
